<footer class="eq-footer eq-relative eq-bg-white eq-mt-10 lg:eq-mt-[140px]">
  <div class="eq-footer-top eq-container">
    <div class="eq-footer-top-conts">
      <div class="eq-flex eq-relative eq-h-full eq-z-[1]">
        <div class="eq-self-center">
          <img [src]="rendering.fields?.LogoImage?.value?.src" alt="rendering.fields?.LogoImage?.value?.alt">
        </div>
        <div class="eq-hidden eq-right-data lg:eq-flex eq-gap-[35px] eq-ml-[20%] eq-self-center">
          <div class="eq-flex eq-gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
              <g clip-path="url(#clip0_5220_10980)">
                <path d="M14.4525 11.7586L11.7425 14.4686L4.51649 7.24162L7.22649 4.53162L2.71049 0.015625L0.000488281 2.72563C0.000488281 7.03778 1.71349 11.1733 4.76264 14.2225C7.81179 17.2716 11.9473 18.9846 16.2595 18.9846L18.9695 16.2746L14.4525 11.7586Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_5220_10980">
                  <rect width="18.969" height="18.969" fill="white" transform="translate(0.000488281 0.015625)"/>
                </clipPath>
              </defs>
            </svg>
            <a [href]="'tel:' + rendering.fields?.TelephoneNumber.value" class="eq-text-white eq-text-body-sm-m lg:eq-text-body-sm" *scText="rendering.fields?.TelephoneNumber"></a>
          </div>
          <div class="eq-flex eq-gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
              <g clip-path="url(#clip0_5220_10989)">
                <path d="M12.8506 11.8052C12.4863 12.0549 12.0507 12.1794 11.6095 12.1603C11.1697 12.1786 10.7357 12.054 10.3725 11.8052L0.971924 6.75195V15.7055C0.971924 16.4107 1.25208 17.0871 1.75077 17.5858C2.24946 18.0844 2.92582 18.3646 3.63107 18.3646H19.588C20.2932 18.3646 20.9696 18.0844 21.4683 17.5858C21.967 17.0871 22.2471 16.4107 22.2471 15.7055V6.75195L12.8506 11.8052Z" fill="white"/>
                <path d="M19.588 0.634766H3.6311C2.92585 0.634766 2.24949 0.914925 1.7508 1.41361C1.25211 1.9123 0.971951 2.58867 0.971951 3.29392V4.17997C0.970724 4.34017 1.01086 4.49798 1.08847 4.63813C1.16608 4.77828 1.27854 4.89604 1.41498 4.98001L11.1665 10.2993C11.3026 10.3709 11.4564 10.4018 11.6096 10.3883C11.7627 10.4018 11.9165 10.3709 12.0526 10.2993L21.8041 4.98001C21.9406 4.89604 22.053 4.77828 22.1306 4.63813C22.2082 4.49798 22.2484 4.34017 22.2472 4.17997V3.29392C22.2472 2.58867 21.967 1.9123 21.4683 1.41361C20.9696 0.914925 20.2933 0.634766 19.588 0.634766Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_5220_10989">
                  <rect width="21.2762" height="17.73" fill="white" transform="translate(0.971924 0.634766)"/>
                </clipPath>
              </defs>
            </svg>
            <a [href]="'mailto:' + rendering.fields?.Email.value" class="eq-text-white eq-text-body-sm-m lg:eq-text-body-sm" *scText="rendering.fields?.Email"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:eq-hidden eq-mt-[41px]">
      <div class="eq-flex eq-flex-col eq-gap-5">
        <a [href]="'tel:' + rendering.fields?.TelephoneNumber.value" class="eq-h-9 eq-pl-7 eq-pr-7 eq-pt-[10px] eq-pb-[10px] eq-flex eq-gap-2 eq-text-[#0050B5] eq-text-body-sm-m eq-font-bold eq-bg-white eq-shadow-[0px_1px_4px_0px_rgba(0,0,0,0.20)]">
          <i class="eq-icons eq-icon-phone_contact eq-text-[26px] eq-self-center"></i>
          <div class="eq-flex eq-flex-col">
            <div *scText="rendering.fields?.TelephoneNumberMobileLabel"></div>
            <div *scText="rendering.fields?.TelephoneNumber"></div>
          </div>
        </a>
        <a [href]="'mailto:' + rendering.fields?.Email.value" class="eq-h-9 eq-pl-7 eq-pr-7 eq-pt-[10px] eq-pb-[10px] eq-flex eq-gap-2 eq-text-[#0050B5] eq-text-body-sm-m eq-font-bold eq-bg-white eq-shadow-[0px_1px_4px_0px_rgba(0,0,0,0.20)]">
          <i class="eq-self-center eq-icons eq-icon-email eq-text-[26px]"></i>
          <div class="eq-self-center" *scText="rendering.fields?.Email"></div>
        </a>
      </div>
    </div>
    <div class="lg:eq-pt-[60px]">
      <div class="eq-flex eq-flex-col eq-gap-6 lg:eq-gap-[30px]">
        <div class="eq-hidden lg:eq-block eq-w-[85%] eq-mx-auto">
          <div class="lg:eq-grid lg:eq-grid-cols-3">
            <div class="lg:eq-px-[10px] lg:eq-pb-[18px] lg:eq-pt-[2px]">
              <div class="eq-text-body-m lg:eq-text-body eq-text-blue-darkBlue lg:eq-mb-[25px]" *scText="rendering.fields?.ColumnOneLabel"></div>
              <div *ngFor="let column1Item of rendering.fields?.ColumnOneItems; let i = index" class="eq-text-body-xs-m lg:eq-text-body-xs eq-text-blue-darkBlue lg:eq-pb-[15px]">
                <a *ngIf="column1Item?.fields?.Link?.value?.href" hybridHref href="{{column1Item?.fields?.Link?.value?.href}}" attr.label="{{column1Item?.fields?.Link?.value?.text}}">{{column1Item?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
            <div class="lg:eq-px-[10px] lg:eq-pb-[33px]">
              <div class="eq-text-body-m lg:eq-text-body eq-text-blue-darkBlue lg:eq-mb-[25px]" *scText="rendering.fields?.ColumnTwoLabel"></div>
              <div *ngFor="let column2Item of rendering.fields?.ColumnTwoItems; let y = index" class="eq-text-body-xs-m lg:eq-text-body-xs eq-text-blue-darkBlue lg:eq-pb-[15px]">
                <a *ngIf="column2Item?.fields?.Link?.value?.href" hybridHref href="{{column2Item?.fields?.Link?.value?.href}}" attr.label="{{column2Item?.fields?.Link?.value?.text}}">{{column2Item?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
            <div class="lg:eq-px-[10px] lg:eq-pb-[33px]">
              <div class="eq-text-body-m lg:eq-text-body eq-text-blue-darkBlue lg:eq-mb-[25px]" *scText="rendering.fields?.ColumnThreeLabel"></div>
              <div *ngFor="let column3Item of rendering.fields?.ColumnThreeItems; let z = index" class="eq-text-body-xs-m lg:eq-text-body-xs eq-text-blue-darkBlue lg:eq-pb-[15px]">
                <a *ngIf="column3Item?.fields?.Link?.value?.href" hybridHref href="{{column3Item?.fields?.Link?.value?.href}}" attr.label="{{column3Item?.fields?.Link?.value?.text}}" [target]="column3Item?.fields?.Link?.value?.target">{{column3Item?.fields?.Link?.value?.text}}</a>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:eq-hidden eq-pt-6">
          <div class="eq-footer-accordion">
            <dl
              class="eq-border-b eq-border-b-black-natural-60"
              [ngClass]="expanded1 ? 'eq-bg-white lg:eq-bg-transparent' : ''"
            >
              <dt
                class="eq-flex eq-justify-between eq-text-blue-darkBlue eq-cursor-pointer eq-py-[18px]"
                (click)="expand1()"
                [class.eq-accordion--expanded]="expanded1 == true"
              >
                <div class="eq-text-body-m !eq-font-normal" *scText="rendering.fields.ColumnOneLabel"></div>
                <i
                  class="flex items-center eq-text-blue-darkBlue eq-icons eq-icon-chevron_down eq-text-[20px]"
                ></i>
              </dt>
              <ng-container *ngFor="let item of rendering.fields.ColumnOneItems">
                <dd>
                  <a *ngIf="item?.fields?.Link?.value?.href" hybridHref class="eq-text-body-sm-m" href="{{item?.fields?.Link?.value?.href}}" attr.label="{{item?.fields?.Link?.value?.text}}" >{{item?.fields?.Link?.value?.text}}</a>
                </dd>
              </ng-container>
            </dl>
          </div>
          <div class="eq-footer-accordion">
            <dl
              class="eq-border-b eq-border-b-black-natural-60"
              [ngClass]="expanded2 ? 'eq-bg-white lg:eq-bg-transparent' : ''"
            >
              <dt
                class="eq-flex eq-justify-between eq-text-blue-darkBlue eq-cursor-pointer eq-py-[18px]"
                (click)="expand2()"
                [class.eq-accordion--expanded]="expanded2 == true"
              >
                <div class="eq-text-body-m !eq-font-normal" *scText="rendering.fields.ColumnTwoLabel"></div>
                <i
                  class="flex items-center eq-text-blue-darkBlue eq-icons eq-icon-chevron_down eq-text-[20px]"
                ></i>
              </dt>
              <ng-container *ngFor="let item of rendering.fields.ColumnTwoItems">
                <dd>
                  <a *ngIf="item?.fields?.Link?.value?.href" hybridHref class="eq-text-body-sm-m" href="{{item?.fields?.Link?.value?.href}}" attr.label="{{item?.fields?.Link?.value?.text}}">{{item?.fields?.Link?.value?.text}}</a>
                </dd>
              </ng-container>
            </dl>
          </div>
          <div class="eq-footer-accordion">
            <dl
              class="eq-border-b eq-border-b-black-natural-60"
              [ngClass]="expanded3 ? 'eq-bg-white lg:eq-bg-transparent' : ''"
            >
              <dt
                class="eq-flex eq-justify-between eq-text-blue-darkBlue eq-cursor-pointer eq-py-[18px]"
                (click)="expand3()"
                [class.eq-accordion--expanded]="expanded3 == true"
              >
                <div class="eq-text-body-m !eq-font-normal" *scText="rendering.fields.ColumnThreeLabel"></div>
                <i
                  class="flex items-center eq-text-blue-darkBlue eq-icons eq-icon-chevron_down eq-text-[20px]"
                ></i>
              </dt>
              <ng-container *ngFor="let item of rendering.fields.ColumnThreeItems">
                <dd>
                  <a *ngIf="item?.fields?.Link?.value?.href" hybridHref class="eq-text-body-sm-m" href="{{item?.fields?.Link?.value?.href}}" attr.label="{{item?.fields?.Link?.value?.text}}" [target]="item?.fields?.Link?.value?.target">{{item?.fields?.Link?.value?.text}}</a>
                </dd>
              </ng-container>
            </dl>
          </div>
        </div>
        <div class="lg:eq-w-[85%] lg:eq-mx-auto lg:eq-border-t-[1px] lg:eq-border-t-solid lg:eq-border-t-[var(--grey-shades-natural-black-60,#737373)]">
          <div class="eq-text-center lg:eq-text-start lg:eq-flex lg:eq-justify-between eq-text-body-xs-m lg:eq-text-body-xs eq-text-black-natural-80 lg:eq-pt-7 lg:eq-pb-7">
            <div *scText="rendering.fields?.CopyrightLabel" class="eq-pb-6 lg:eq-pb-0"></div>
            <div *scText="rendering.fields?.LicenseLabel" class="eq-pb-6 lg:eq-pb-0"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>